import { Link, useNavigate, useLocation } from 'react-router-dom'
import i18n from 'i18next'
import { AppstoreOutlined, FormOutlined, BankOutlined, MailOutlined, AuditOutlined, FileDoneOutlined } from '@ant-design/icons'

import { routes } from '@/router'
import '@/components/menu-item/index.scss'
import smallLogo from '@/assets/logo.png'

export const Sidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/')

  return (
    <aside className="sidebar flex h-screen flex-col justify-start p-5">
      <Link to={routes.DASHBOARD} className="flex items-center">
        <img className="h-auto w-[30px] cursor-pointer object-contain brightness-0 invert" src={smallLogo} />
        <span className="ml-[32px] font-logo text-[16px] font-bold text-white">Ciphia Platform</span>
      </Link>
      <div className="mb-3 mt-8 border-t border-white/10" />
      <div className="flex flex-1 flex-col">
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive(routes.DASHBOARD) ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: routes.DASHBOARD })
          }}
        >
          <AppstoreOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('sidebar.dashboard')}</span>
        </a>
        <div className="mb-2 mt-2 border-t border-white/10" />
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive(routes.DIAGNOSTICS) ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: routes.DIAGNOSTICS })
          }}
        >
          <FormOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('sidebar.diagnostics')}</span>
        </a>
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive(routes.PHISHING) ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: routes.PHISHING })
          }}
        >
          <MailOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('phishing_ui.page_title')}</span>
        </a>
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive(routes.CONTROL_ASSESSMENT) ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: routes.CONTROL_ASSESSMENT })
          }}
        >
          <AuditOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('sidebar.control_assessment')}</span>
        </a>
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive('/compliance-reports') ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: '/compliance-reports/builder' })
          }}
        >
          <FileDoneOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('sidebar.compliance_reports')}</span>
        </a>
        <div className="mb-2 mt-2 border-t border-white/10" />
        <a
          href="#"
          className={`menu-item mb-1 flex ${isActive(routes.COMPANY) ? 'active' : ''}`}
          onClick={e => {
            e.preventDefault()
            navigate({ pathname: routes.COMPANY })
          }}
        >
          <BankOutlined className="text-[15px]" />
          <span className="ml-3 text-[15px] font-semibold">{i18n.t('sidebar.company')}</span>
        </a>
      </div>
    </aside>
  )
}
